var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-shell',{attrs:{"breadcrumbs":"Documentation"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('iframe',{staticStyle:{"width":"100%","height":"99vh","align-content":"center","text-align":"center"},attrs:{"src":"https://tingg.gitbook.io/checkout/"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6f59fe6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Documentation.vue
// module id = 470
// module chunks = 1